"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
var tslib_1 = require("tslib");
var client_1 = require("./client/client");
var BaseService = /** @class */ (function () {
    function BaseService(path, authorization, baseUrl) {
        var url = baseUrl.replace(/\/$/, '') + path;
        this.client = (0, client_1.createClient)(url, {
            headers: {
                Authorization: authorization,
            },
        });
    }
    BaseService.prototype.requestRecursively = function (query, getter, params) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var request;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_a) {
                request = function (cursor) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                    var response, _a, nextCursor, items, _b;
                    return (0, tslib_1.__generator)(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, this.client.request(query, (0, tslib_1.__assign)((0, tslib_1.__assign)({}, params), { cursor: cursor }))];
                            case 1:
                                response = _c.sent();
                                _a = getter(response), nextCursor = _a.cursor, items = _a.items;
                                if (!nextCursor) return [3 /*break*/, 3];
                                _b = [(0, tslib_1.__spreadArray)([], items, true)];
                                return [4 /*yield*/, request(nextCursor)];
                            case 2: return [2 /*return*/, tslib_1.__spreadArray.apply(void 0, _b.concat([(_c.sent()), true]))];
                            case 3: return [2 /*return*/, items];
                        }
                    });
                }); };
                return [2 /*return*/, request()];
            });
        });
    };
    return BaseService;
}());
exports.BaseService = BaseService;
//# sourceMappingURL=base-service.js.map